import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { images } from "../../assets";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("0px"),
  },
  "& .MuiPaper-root": {
    width: "400px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    borderRadius: "6px",
    position: "absolute",
    zIndex: 9999,
    bottom: "50px",
    right: "0px",
    transform: "translateY(0)",
  },
}));

let paramsData = {};

const UserChatDialog = forwardRef(({ socket }, ref) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([]);
  const userId = localStorage.getItem("userId");
  const chatEndRef = useRef(null); // Create a ref for the chat container

  useEffect(() => {
    // Fetch chat history on reload
    socket.emit("fetchChatHistory", userId);

    socket.on("chatHistory", (messages) => {
      setChat(messages);
    });

    socket.on("userResponse", (msg) => {
      setChat((prevChat) => [
        ...prevChat,
        { sender: "admin", message: msg.message, createdAt: new Date() },
      ]);
    });

    return () => {
      socket.off("chatHistory");
      socket.off("userResponse");
    };
  }, []);

  useEffect(() => {
    // Scroll to the bottom of the chat when it updates
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chat]);

  const sendMessage = () => {
    if (message) {
      // User ka message bhejna admin ko
      socket.emit("userMessage", { message, userId });

      // Apne message ko chat mein dikhana
      setChat((prevChat) => [
        ...prevChat,
        { sender: "user", message, createdAt: new Date() },
      ]);
      setMessage("");
    }
  };

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
      // Wait for the dialog to open before scrolling to the bottom
      setTimeout(() => {
        if (chatEndRef.current) {
          chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 0); // Timeout to ensure the UI has updated before scrolling
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      hideBackdrop
      disableScrollLock
    >
      <Stack
        p={1.5}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Avatar
            src={images.webMiniLogoImg}
            sx={{
              height: 28,
              width: 28,
              padding: "4px",
              border: "1px solid #000000",
            }}
          />
          <Box>
            <Typography
              variant="body1"
              fontWeight={500}
              color={"#000000"}
              lineHeight={1}
            >
              Customer Support
            </Typography>
            <Typography variant="body2" color={"#938d8d"} lineHeight={1.3}>
              Available
            </Typography>
          </Box>
        </Stack>
        <IconButton onClick={() => setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent dividers>
        <Stack height={"300px"} spacing={1.5} overflow="auto" padding={1.5}>
          {chat.map((msg, index) => {
            const isSender = msg.sender === "user";
            const createdTime = msg?.createdAt;
            return (
              <Stack
                p={1}
                key={index}
                borderRadius={"6px"}
                maxWidth={"320px"}
                bgcolor={isSender ? "#e1faff" : "#fffc8f"}
                alignSelf={isSender ? "flex-end" : "flex-start"}
              >
                <Typography variant="body2">{msg.message}</Typography>
                <Typography mt={0.3} fontSize={"0.7rem"}>
                  {moment(createdTime).format("DD-MM-YYYY hh:mm a")}
                </Typography>
              </Stack>
            );
          })}
          {/* This empty div will help in scrolling to the bottom */}
          <div ref={chatEndRef} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <TextField
          fullWidth
          size="small"
          placeholder="What can we help you with?"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
              outline: "none",
            },
          }}
        />
        <Button
          disableRipple
          endIcon={<SendIcon />}
          onClick={sendMessage}
          sx={{
            minWidth: "48px",
            padding: "0px",

            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        ></Button>
      </DialogActions>
    </BootstrapDialog>
  );
});

export default UserChatDialog;
